/** 日期与数字的展示格式。ISO 日期一律按字面解析，不经过 `Date` 的时区换算。 */
const WEEKDAYS = ['日', '一', '二', '三', '四', '五', '六'] as const;

/** `2026-09-19` → `2026 年 9 月 19 日` */
export function formatDate(iso: string): string {
  const [year, month, day] = iso.split('-');
  if (!year || !month || !day) return iso;
  return `${year} 年 ${Number(month)} 月 ${Number(day)} 日`;
}

/** `2026-09-19` → `2026-09-19`，列表里用紧凑写法。 */
export function formatDateCompact(iso: string): string {
  return iso;
}

/** `2026-09-19` → `2026-09-19 · 周六` */
export function formatDateWithWeekday(iso: string): string {
  const [year, month, day] = iso.split('-');
  if (!year || !month || !day) return iso;
  const date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
  return `${iso} · 周${WEEKDAYS[date.getUTCDay()]}`;
}

/** 大数字的统一写法：整数保持整数，小数最多两位，千位不加分隔符（遥测值不需要）。 */
export function formatNumber(value: number, fractionDigits = 0): string {
  if (!Number.isFinite(value)) return '—';
  return value.toFixed(fractionDigits);
}
